module.exports = __webpack_public_path__ + "static/oab_pe-8400460f3b0d7535a0ade6eefc81f11a.png";